import type { FC } from 'react';
import cx from 'classnames';

import { BrazeBanner } from 'Components/BrazeBanner/BrazeBanner';
import { BRAZE_BANNERS_ID } from 'Components/BrazeBanner/BrazeBanner.helpers';
import { AccountSlugs } from 'Types/account';

import type { VehicleListQuery } from '../AccountPage.types';
import { Filters } from '../Filters/Filters';
import { isDidntWinPage } from '../Purchases/Purchases.helpers';

import { BidsAndOffersVehicleList } from './BidsAndOffersVehicleList/BidsAndOffersVehicleList';

import styles from './BidsAndOffers.module.scss';

type BidsAndOffersProps = VehicleListQuery & {
	isPreviousData: boolean;
	slug: AccountSlugs;
};

const BidsAndOffers: FC<BidsAndOffersProps> = ({ data, isPreviousData, queryStatus, slug }) => {
	return (
		<div className={styles.container}>
			<Filters
				data={data}
				gridClass={cx({
					[styles.didntWinGrid]: isDidntWinPage(slug),
					[styles.othersGrid]: !isDidntWinPage(slug),
				})}
				queryStatus={queryStatus}
			/>
			{slug === AccountSlugs.ACTIVE && (
				<BrazeBanner bannerId={BRAZE_BANNERS_ID.ACTIVE_BIDS} className={styles.brazeKycBanner} />
			)}
			<BidsAndOffersVehicleList data={data} isPreviousData={isPreviousData} queryStatus={queryStatus} />
		</div>
	);
};

export { BidsAndOffers };
